import Swiper from 'swiper/bundle'; // 全ての機能が入っている

const swiper = new Swiper('.swiper', {
    slidesPerView: 2,
    spaceBetween: 30,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".fa-arrow-left",
        prevEl: ".fa-arrow-right",
    },
    breakpoints:{
        768:  {
            slidesPerView: 3,
        }
    },
});

const swiper_Beauty = new Swiper('.swiper_Beauty', {
    slidesPerView: 1,
    spaceBetween: 30,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".fa-arrow-left",
        prevEl: ".fa-arrow-right",
    },
    breakpoints:{
        768:  {
            slidesPerView: 3,
        }
    },
});

$(document).ready(function() {
    $('.drawer').drawer();
});

window.onload = function() {
    scroll_top_effect();
    PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/

    $(window).scroll(function(){
        scroll_top_effect();
        PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
    });

    function scroll_top_effect(){
        $('#header').each(function(){
            var scroll = $(window).scrollTop();
            if (scroll < 200 ){
                $(this).removeClass('scroll');
            } else {
                $(this).addClass('scroll');
            }
        });
    }

    //スクロールした際の動きを関数でまとめる
    function PageTopAnime() {

        var scroll = $(window).scrollTop(); //スクロール値を取得
        if (scroll >= 200){//200pxスクロールしたら
            $('#page-top').removeClass('DownMove');   // DownMoveというクラス名を除去して
            $('#page-top').addClass('UpMove');      // UpMoveというクラス名を追加して出現
        }else{//それ以外は
            if($('#page-top').hasClass('UpMove')){//UpMoveというクラス名が既に付与されていたら
                $('#page-top').removeClass('UpMove'); //  UpMoveというクラス名を除去し
                $('#page-top').addClass('DownMove');  // DownMoveというクラス名を追加して非表示
            }
        }
        
        var wH = window.innerHeight; //画面の高さを取得
        var footerPos =  $('#site-footer').offset().top; //footerの位置を取得
        if(scroll+wH >= (footerPos+10)) {
            var pos = (scroll+wH) - footerPos+10 //スクロールの値＋画面の高さからfooterの位置＋10pxを引いた場所を取得し
            $('#page-top').css('bottom',pos); //#page-topに上記の値をCSSのbottomに直接指定してフッター手前で止まるようにする
            }else{//それ以外は
            if($('#page-top').hasClass('UpMove')){//UpMoveというクラス名がついていたら
                $('#page-top').css('bottom','10px');// 下から10pxの位置にページリンクを指定
            }
        }
    }

    // #page-topをクリックした際の設定
    $('#page-top').click(function () {
        $('body,html').animate({
            scrollTop: 0//ページトップまでスクロール
        }, 500);//ページトップスクロールの速さ。数字が大きいほど遅くなる
        return false;//リンク自体の無効化
    });
};

$(function() {
// #(ハッシュ)指定されたタブを表示する
var hash = document.location.hash;
console.log(hash);
    if (hash) {
        var triggerEl = document.querySelector('button[data-bs-target="' + hash + '"]')
        var tab = new bootstrap.Tab(triggerEl);
        tab.show();
    }
    var tabEl = document.querySelector('button[data-bs-toggle="pill"]');
        tabEl.addEventListener("shown.bs.tab", function (event) {
        event.target; // newly activated tab
        event.relatedTarget; // previous active tab
    });
});

const vip_seat = document.getElementById("vip_num");
const s_seat = document.getElementById("s_num");
const a_seat = document.getElementById("a_num");
const b_seat = document.getElementById("b_num");
vip_seat.addEventListener("change", changeText);
s_seat.addEventListener("change", changeText);
a_seat.addEventListener("change", changeText);
b_seat.addEventListener("change", changeText);




function changeText() {
    const subtotal_vip = 15000 * vip_seat.value;
    const subtotal_s = 12000 * s_seat.value;
    const subtotal_a = 10000 * a_seat.value;
    const subtotal_b = 5000 * b_seat.value;

    document.getElementById("subtotal_vip").textContent = Number(subtotal_vip).toLocaleString();
    document.getElementById("subtotal_s").textContent = subtotal_s.toLocaleString();
    document.getElementById("subtotal_a").textContent = subtotal_a.toLocaleString();
    document.getElementById("subtotal_b").textContent = subtotal_b.toLocaleString();

    document.querySelector("input[name = 'subtotal_vip']").value = Number(subtotal_vip).toLocaleString();
    document.querySelector("input[name = 'subtotal_s']").value = Number(subtotal_s).toLocaleString();
    document.querySelector("input[name = 'subtotal_a']").value = Number(subtotal_a).toLocaleString();
    document.querySelector("input[name = 'subtotal_b']").value = Number(subtotal_b).toLocaleString();

    const total = subtotal_vip + subtotal_s + subtotal_a + subtotal_b;
    document.getElementById("total").textContent = total.toLocaleString();
    if (total <= 0) {
        document.querySelector("input[name = 'total']").value = "";
    } else {
        document.querySelector("input[name = 'total']").value = total.toLocaleString();
    }
}

function submitStop(e){
    if (!e) var e = window.event;
    if(e.keyCode == 13)
    return false;
}

window.onload = function () {
    changeText();

    var list = document.getElementsByTagName("input");
    for(var i=0; i<list.length; i++){
        if(list[i].type == 'email' || list[i].type == 'password'|| list[i].type == 'text'|| list[i].type == 'number'|| list[i].type == 'tel'){
            list[i].onkeypress = function (event){
                return submitStop(event);
            };
        }
    }
    
}

